import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Send page view to GTM dataLayer
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: location.pathname + location.search,
      },
    });
  }, [location]);
}
